import React, { createContext, useCallback, useContext, useMemo, useState } from "react";

const TermsModalContext = createContext(null);

export const TermsModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openTerms = useCallback(() => setOpen(true), []);
  const closeTerms = useCallback(() => setOpen(false), []);

  const value = useMemo(
    () => ({ open, openTerms, closeTerms }),
    [open, openTerms, closeTerms]
  );

  return (
    <TermsModalContext.Provider value={value}>{children}</TermsModalContext.Provider>
  );
};

export const useTermsModal = () => {
  const context = useContext(TermsModalContext);
  if (!context) {
    throw new Error("useTermsModal must be used within TermsModalProvider");
  }
  return context;
};
